var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.dataForm, "label-width": "120px" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "名称" },
                model: {
                  value: _vm.dataForm.displayName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "displayName", $$v)
                  },
                  expression: "dataForm.displayName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据集代码", prop: "description" } },
            [
              _c("el-input", {
                attrs: { placeholder: "数据集代码" },
                model: {
                  value: _vm.dataForm.datasetCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "datasetCode", $$v)
                  },
                  expression: "dataForm.datasetCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "表名", prop: "description" } },
            [
              _c("el-input", {
                attrs: { placeholder: "表名" },
                model: {
                  value: _vm.dataForm.tableName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "tableName", $$v)
                  },
                  expression: "dataForm.tableName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }